import { getApiBaseUrl } from "../api/client";

function apiOrigin() {
  const base = String(getApiBaseUrl() || "").trim();
  if (!base || base.startsWith("/")) {
    return typeof window !== "undefined" ? window.location.origin : "";
  }

  try {
    return new URL(base).origin;
  } catch {
    return "";
  }
}

function currentProtocol() {
  return typeof window !== "undefined" ? window.location.protocol : "https:";
}

function safeAbsoluteImageUrl(raw) {
  try {
    const url = new URL(raw);
    return ["http:", "https:", "blob:"].includes(url.protocol) ? raw : "";
  } catch {
    return "";
  }
}

/**
 * Resuelve solamente referencias de imagen que el WebBuilder puede mostrar de
 * forma segura. Las rutas de assets administrados se normalizan contra el
 * backend; referencias relativas desconocidas o esquemas no aptos se tratan
 * como inválidos en vez de producir una preview rota.
 */
export function resolveLandingAssetUrl(value) {
  const raw = String(value || "").trim();
  if (!raw || /[\u0000-\u001F\u007F]/.test(raw)) return "";

  if (/^data:image\//i.test(raw)) return raw;
  if (/^blob:/i.test(raw)) return safeAbsoluteImageUrl(raw);
  if (/^https?:\/\//i.test(raw)) return safeAbsoluteImageUrl(raw);
  if (raw.startsWith("//")) return safeAbsoluteImageUrl(`${currentProtocol()}${raw}`);

  const normalized = raw.replace(/\\/g, "/");
  const origin = apiOrigin();

  if (normalized.startsWith("files/")) return `${origin}/${normalized}`;
  if (normalized.startsWith("/files/")) return `${origin}${normalized}`;
  if (normalized.startsWith("projects/")) return `${origin}/files/${normalized}`;
  if (normalized.startsWith("/projects/")) return `${origin}/files${normalized}`;

  if (normalized.startsWith("/static/") || normalized.startsWith("/assets/")) {
    return normalized;
  }
  if (normalized.startsWith("/")) return normalized;

  return "";
}

export function assetValueFromResponse(response) {
  const asset = response?.asset || {};
  if (asset.publicPath) return asset.publicPath;
  if (asset.path) return `/files/${String(asset.path).replace(/^\/+/, "")}`;
  return asset.url || "";
}

export function isManagedLandingAsset(value) {
  const raw = String(value || "").trim();
  if (!raw) return false;

  try {
    const pathname = /^https?:\/\//i.test(raw) ? new URL(raw).pathname : raw;
    return /(?:^|\/)files\/projects\/[^/]+\/landing\//i.test(pathname);
  } catch {
    return false;
  }
}

export function fileLabelFromAsset(value) {
  const raw = String(value || "").trim();
  if (/^data:image\//i.test(raw)) return "Imagen embebida";
  if (/^blob:/i.test(raw)) return "Preview temporal";

  const clean = raw.split(/[?#]/, 1)[0].replace(/\\/g, "/");
  const parts = clean.split("/").filter(Boolean);
  const label = parts[parts.length - 1] || "Referencia guardada";
  return label.length > 96 ? `${label.slice(0, 93)}…` : label;
}
